import { ValidationModel, ValidationType } from "@/services/validation/types";

export const boardValidators = {
    name: {
        rules: [
            { type: ValidationType.Required }
        ]
    } as ValidationModel,
    timeZone: {
        rules: [
            { type: ValidationType.Required }
        ]
    } as ValidationModel,
    type: {
        rules: [
            { type: ValidationType.Required }
        ]
    } as ValidationModel
};
